import { render, staticRenderFns } from "./IconPointDetail..vue?vue&type=template&id=298da55a&"
import script from "./IconPointDetail..vue?vue&type=script&lang=js&"
export * from "./IconPointDetail..vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports